import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchOrderById } from "../utils/api";

const OrderDetails = () => {
    const { id } = useParams();
    const [order, setOrder] = useState(null);

    useEffect(() => {
        getOrder();
    }, []);

    const getOrder = async () => {
        try {
            const data = await fetchOrderById(id);
            setOrder(data);
        } catch (error) {
            console.error("Feil ved henting av ordre:", error);
        }
    };

    if (!order) return <p className="p-4 text-gray-600 text-center">Laster ordre...</p>;

    return (
        <div className="p-4 md:p-6">
            <h1 className="text-xl md:text-2xl font-bold text-gray-800">Ordredetaljer</h1>
            <p className="text-xs md:text-s text-gray-400 md:text-end" >#{order.sessionId}</p>
            <div className="bg-white shadow-md rounded-lg p-4 md:p-6 mt-4 text-xs md:text-sm gap-3">
                <p><strong>Navn:</strong> {order.customerName}</p>
                <p><strong>E-post:</strong> {order.customerEmail}</p>
                <p><strong>Telefon:</strong> {order.customerPhone}</p>
                <p><strong>Leveringsmetode:</strong> {order.deliveryMethod === "pickup" ? "Henting" : "Levering"}</p>
                {order.deliveryMethod === "delivery" && <p><strong>Adresse:</strong> {order.customerAddress.address}, {order.customerAddress.postalCode} {order.customerAddress.city}</p>}
                <p><strong>Status:</strong> {order.status === "pending" ? "Venter" : "Fullført"}</p>
                <p><strong>Total:</strong> {order.totalAmount} NOK</p>

                <h2 className="text-lg md:text-xl font-bold mt-4">Produkter</h2>
                <ul className="mt-2 space-y-2">
                    {order.items.map((item, index) => (
                        <li key={index} className="border-b py-2 flex flex-col md:flex-row justify-between">
                            <span><strong>{item.productId.name}</strong></span>
                            <span>{item.quantity} stk.</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default OrderDetails;
